import * as Yup from 'yup';

const customerSchema = Yup.object({
  number: Yup.number()
    .required()
    .label('Asiakasnumero'),
  company: Yup.string()
    .required()
    .label('Yritys')
});

export default customerSchema;
export type CustomerSchema = ReturnType<typeof customerSchema.cast>;
